// src/index.js for sipnscore-customer
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// Build version injected at build time, falls back to static string
const BUILD_VERSION = process.env.REACT_APP_BUILD_TIME || "20260320v2";
window.__SIPNSCORE_BUILD__ = BUILD_VERSION;

// Cache-busting: only clear stale QR data on new deploy.
// Do NOT clear disclaimer, user data, or force reload, these destroy active sessions.
const STORED_BUILD_KEY = "sipnscore_build_version";
const storedBuild = localStorage.getItem(STORED_BUILD_KEY);
if (storedBuild && storedBuild !== BUILD_VERSION) {
  // New build deployed - only clear QR cache (it may reference stale event data)
  localStorage.removeItem("sipnscore_qr_data");
}
localStorage.setItem(STORED_BUILD_KEY, BUILD_VERSION);

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
